import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-48" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-49" data-mp="1nwmetz0a1iw7">
        <div className="mb-12 text-center" data-id="element-50" data-mp="2blf2l86qwkfq">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-teal" data-id="element-51" data-mp="2bmgok7paurc8">GOOD TO KNOW</p>
          <h2 className="text-3xl font-black text-brand-blue md:text-4xl" data-id="element-52" data-mp="2fns7judo4ebg">Frequently Asked Questions</h2>
        </div>
        <div className="space-y-3" data-id="element-53" data-mp="26tningi3hcyk">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-blue/[0.06] bg-brand-alt" data-id="element-54" data-mp="2zagfp8qiwjrc" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left font-bold text-brand-blue focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-orange" data-id="element-55" data-mp="1vqszc3cyt7m2">
                  <span data-id="element-56" data-mp="2ffl9tv82m404">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-57" data-mp="2ae5qc7ljk5ju" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-58" data-mp="2oc2m51s687xg" />}
                </button>
                <AnimatePresence initial={false} data-id="element-59" data-mp="tzm6xbhedjgg">
                  {open && <motion.div id={panelId} role="region" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} data-id="element-60" data-mp="p1kngpg27i4g">
                      <p className="px-6 pb-6 leading-relaxed text-brand-gray" data-id="element-61" data-mp="2z0gj3435afqh">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}